import PROFILE from './info/profile'
import LINE_SPECIAL from './info/lineSpecial'

const COLLECTION_ICONS_DIR = '/static/img/recommend/lp/common/collection_icons/'
export const colorScheme = {
  keyColor: '#00462e',
  second: '#3a89c9',
  gradStart: '#7cda9f',
  gradEnd: '#5198dd',
  baseBg: '#00462e', // ヘッダ用のBGとして使用(指定がない場合はgradStart,gradEndを使用し標準パラメータでグラデーションを描画)
  messBg: '#f3ffef',
  profileKeyColor: '#4bcb7b',
}

const pathCommon = '/static/img/recommend/lp/common/'
const pathCounselor = '/static/img/recommend/lp/houen/'
const deco = ''
const kira = `${pathCounselor}kira.png`
const counselor = `${pathCounselor}counselor.png`

const SUBSC_MENU_NUM = 55 //サブスクメニュー数

const hero = {
  pc: `${pathCounselor}top_sp_20220519.webp`,
  sp: `${pathCounselor}top_sp_20220519.webp`,
  fallback_pc: `${pathCounselor}top_sp_20220519.jpg`,
  fallback_sp: `${pathCounselor}top_sp_20220519.jpg`,
  alt: '無限の包容力でどんな闇にも光を届ける太陽の母 法演（ほうえん）',
}

const about = {
  // deco: deco,
  img: `${pathCounselor}about.webp`,
  headline: '占い監修：法演（ほうえん）',
  text: 'どんな過ちも太陽のような笑顔ですべて受け入れ肯定し、その上で今なすべきことから逃げださず、幸せをつかめるよう背中を押す鑑定。痛いところをグッと押されるけれど、受け入れれば視界が開け、すっきり楽になる"心の足つぼマッサージ"のような占いは、病みつきになる芸能人が後を絶たない。',
}

const fortune = {
  // deco: deco,
  headline: 'MITSURIとは',
  text: '秘められた心の裏をつまびらかにする占術。導かれた〈暴露数〉があなたを丸裸にする。<br>目をそらしてきた本当の自分を示す［黒密裏］と、まだ開花していない眠れる才を示す［白密裏］であなたを紐解く。',
  kira: kira,
  you: {
    headline: 'MITSURIで知る<br>あなたのこと',
    text: '手を伸ばした人間だけが、幸せをつかむことができる。真実を知る心の準備は良いですか？',
    comment: '本当の自分を知る勇気を持たなければ、望む未来はやってきません。<br>あなたの為に、きちんとお話します。<br>あなたなら、受け入れて前に進むことができるはず。',
    counselorImage: counselor,
    avatar: `${pathCommon}avatar.png`,
    sample: [
      {
        icon: `${pathCounselor}img_kekka1.png`,
        text: '考えすぎる心配性、でもコツコツ努力できる',
      },
      {
        icon: `${pathCounselor}img_kekka2.png`,
        text: '飽きっぽいけれど、好きなことには一直線',
      },
    ],
    advice: '自分の運命を組み立てて、<br>幸せを掴みに行きましょう。',
  },
  method: {
    headline: 'どんな自分も受け入れれば<br>今なすべきことが分かります',
    text: 'MITSURIがつまびらかにするのは、あなたが見ないようにしてきた本当の自分と、自分でも気付いていない才能。<br>耳の痛いことも聞き入れたあとのあなたは、今よりも視界が開けているでしょう。',
    counselorImage: counselor,
    avatar: `${pathCommon}avatar.png`,
    sample: [
      {
        icon: `${pathCounselor}img_kekka1.png`,
        text: '一度決めたらやり抜く意志の強さがあなたの強み',
      },
      {
        icon: `${pathCounselor}img_kekka2.png`,
        text: '迷ったら自分の気持ちに素直になって',
      },
    ],
    advice: '本当の幸せは<br>本当の自分を知ることから<br>始まります',
  },
  free: {
    text: '自分のタイプが気になった方は、こちらから診断できますよ',
    img: `${pathCounselor}counselor2.png`,
  }
}

const review = {
  // deco: deco,
}

const menu = {
  title: '法演の占いを<br>見てみる',
  // deco: deco,
}

const uTV = {
  // deco: deco,
  counselorImage: `${pathCounselor}counselor3.png`,
  lead: '本当の自分が<br>分かったあなたへ',
  resultBottomCap: `${PROFILE.name}の占いが<br>月額528円（税込）で<br>${SUBSC_MENU_NUM}メニュー占い放題！`
}

export const reviews = [
  { icon: `${pathCommon}icon_review1.png`, review: '誰にも話してないのに、自分の中でうっすら思っていたことをズバリ言い当て驚き！先生と話していると、こちらもパワーをもらえて元気になるのがスゴイ！' },
  { icon: `${pathCommon}icon_review2.png`, review: '自分の中で思い込んでいた事を、違う視点でズバッとアドバイスしてくれ、ハッとするような体験でした。悩みが一瞬のうちに消え、安心して進めるようになりました！' },
  { icon: `${pathCommon}icon_review3.png`, review: '相談後、今までにないぐらい安心できている自分に驚いています。何か見失っていましたが、私は今を大切に生きるしかないんだな、と決心でき前を向くことができました！' },
]

const title = {
  subTitle: '暴露数で本当の自分がわかる',
  title: '法演のMITSURI',
}

const fortuneResult = {
  lead: 'あなたの暴露数は',
  type: 'あなたの黒密裏（短所）',
}

const snsShare = {
  lead: '暴露数をシェアする',
}

const leadMenu = {
  // deco: deco,
  counselorImage: `${pathCounselor}counselor5.png`,
  comment: '<b>本当の自分が見えましたか？<br><br>［白密裏］を読めば、あなたの眠れる才が分かります。</b>',
  // lead: 'あなたのこと、<br>大切な人とのことを<br>詳しく見るなら',
}

const aboutType = {
  // deco: deco,
  title: '法演のMITSURI',
  type: 'あなたの白密裏（長所）',
}

const leadSubsc = {
  // deco: deco,
}

// const advice = {
//   deco: deco,
//   counselorImage: `${pathCounselor}counselor5.png`,
// }

const title2 = {
  // deco: deco,
  subTitle: '＼あなたの周りの人は何タイプ？／',
  title: '法演のMITSURIで<br>占ってみよう',
}

const floatingBanner = {
  enable: true,
  title: '<span class="name">法演</span>の<span class="emphasis">MITSURI</span>で',
  freeBtnFace: '暴露数を占う(無料)',
  colors: {
    background: '#f9f5ed',
    baseText: colorScheme.baseBg,
    emphasis: '#4bcb7b',
    decos: colorScheme.second,
    freeBtn: '#4bcb7b',
    freeBtnBg: 'white',
  }
}

const menuDetails = {
  colors: {
    headBg: colorScheme.baseBg,
    headColor: 'white',
    baseBg: 'white',
    baseColor: colorScheme.baseBg,
    resultBg: '#f5f5f5',
  },
  contents: [
    { icon: `${COLLECTION_ICONS_DIR}icon_collection1.png`, description: '運命の人の顔の特徴は「XX」<br>名前は「○」がつく人' },
    { icon: `${COLLECTION_ICONS_DIR}icon_collection2.png`, description: 'あなたが仕事で成功を手にするきっかけ' },
    { icon: `${COLLECTION_ICONS_DIR}icon_collection3.png`, description: '運命の人とは、どんな形で<br>結婚に至る？' },
    { icon: `${COLLECTION_ICONS_DIR}icon_collection4.png`, description: 'あなたが持っている財運と<br>それを最大限に活かす稼ぎ方' },
    { icon: `${COLLECTION_ICONS_DIR}icon_collection5.png`, description: 'あなたが知っておくべき<br>「弱点」とその「向き合い方」' },
    { icon: `${COLLECTION_ICONS_DIR}icon_collection6.png`, description: 'これまでにあなたが人生で<br>築き上げてきたもの' },
  ],
}

const tabedMenu = {
  color: {
    baseColor: '#4bcb7b',
    itemFont: colorScheme.keyColor,
    frameColor: colorScheme.keyColor,
  }
}

const lineBanner = {
  bannerUrl: '/static/img/recommend/lp/banner/hoen_line_20220217.png'
}

const uTvDesc = {
  leadImg: `${pathCounselor}counselor6.png`,
  lead: 'いかがでしたか？<br>誰にでも長所があれば、短所もあります。そして自分にとっては短所だと思っている部分が、実は人からうらやましがられることも。<br>見方を変えれば、どちらにも転ぶんです。あなたの持って生まれた性質を活かして、幸せな人生を送るためにはどうすればいいのか？<br>もう少し占っていきますね。<br><br>次は、あなたが生まれ持った「宿命」と「運命の人」について、見ていきましょう。',
  points: [{
    img: `${pathCounselor}uTVdesc/point1.png`,
    copy: `${pathCounselor}uTVdesc/point1_copy.png`,
  },{
    img: `${pathCounselor}uTVdesc/point2.png`,
    copy: `${pathCounselor}uTVdesc/point2_copy.png`,
  },{
    img: `${pathCounselor}uTVdesc/point3.png`,
    copy: `${pathCounselor}uTVdesc/point3_copy.png`,
  },{
    img: `${pathCounselor}uTVdesc/point4.png`,
    copy: `${pathCounselor}uTVdesc/point4_copy.png`,
  },{
    img: `${pathCounselor}uTVdesc/point5.png`,
    copy: `${pathCounselor}uTVdesc/point5_copy.png`,
  },{
    img: '__ex__',
    copy: `${pathCounselor}uTVdesc/point6_copy.png`,
    extend: `<img src="${pathCounselor}uTVdesc/point6_copy_pre.png"><div class="seimei"><video src="https://s3-ap-northeast-1.amazonaws.com/uranaitv-town-dev/lp/video_letter/fast/seimei.mp4" autoplay loop muted playsinline></video></div>`
  },],
}

export const information = {
  name: PROFILE.name, // ※互換のため残すが以降についてはprofile.nameを使用すること
  mainMethod: PROFILE.mainMethod, // ※互換のため残すが以降についてはprofile.mainMethodを使用すること
  profile: PROFILE,
  lineSpecial: LINE_SPECIAL,
  hero,
  about,
  fortune,
  review,
  reviews,
  menu,
  uTV,
  title,
  fortuneResult,
  snsShare,
  leadMenu,
  aboutType,
  leadSubsc,
  // advice,
  title2,
  floatingBanner,
  menuDetails,
  tabedMenu,
  lineBanner,
  uTvDesc,
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/recommend/lp/counselor/houen/counselorInfos.js